const contourConfig = {
  id: 'contour',
  label: 'Contour',
  icon: 'contour',
  colors: [
    { name: 'Neutral Brown', hex: '#6A5548' },
    { name: 'Warm Brown', hex: '#7A5A42' },
    { name: 'Olive Brown', hex: '#5A4A38' },
    { name: 'Deep Neutral', hex: '#4A3A32' },
    { name: 'Soft Taupe', hex: '#8A7060' },
    { name: 'Chestnut', hex: '#6B4A38' },
  ],
  finishTypes: [{ id: 'matte', name: 'Matte' }],
  intensityDefault: 40,
  intensityMin: 0,
  intensityMax: 100,
};

export default contourConfig;
